import React from "react";
import ReactDOM from "react-dom/client";
import { register } from "swiper/element/bundle";
import App from "App";
import { GoogleMapsProvider } from "providers/GoogleMapsProvider";
import registerPoppins from "utils/pdfFonts";

//styles
import "swiper/css";
import "react-toastify/dist/ReactToastify.css";
import "swiper/element/css/effect-coverflow";
import "react-loading-skeleton/dist/skeleton.css";
import "react-datepicker/dist/react-datepicker.css";
import "./index.css";

register();
registerPoppins();
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <GoogleMapsProvider>
      <App />
    </GoogleMapsProvider>
  </React.StrictMode>
);
